import { useQuery } from '@tanstack/react-query';
import { teacherEquityReportApi } from '@/features/reports/api';

export type TeacherEquityNationalKpisQueryFilters = {
  year: number | null;
  /** Empty = all roles (query param omitted). */
  roleIds?: string[];
  /** Empty = all qualifications (query param omitted). */
  qualificationIds?: string[];
};

export const teacherEquityNationalKpisQueryKeys = {
  all: ['teacher-equity-report'] as const,
  national: (f: TeacherEquityNationalKpisQueryFilters) =>
    [
      ...teacherEquityNationalKpisQueryKeys.all,
      'national',
      f.year ?? 0,
      [...(f.roleIds ?? [])].sort().join('\0'),
      [...(f.qualificationIds ?? [])].sort().join('\0'),
    ] as const,
};

/** National KPI row from GET /api/app/teacher-equity-report?Year=…&RoleIds=…&QualificationsIds=… — includes `schoolSpreads` for client-side tables. */
export function useTeacherEquityNationalKpisQuery(filters: TeacherEquityNationalKpisQueryFilters) {
  const enabled =
    filters.year != null && Number.isFinite(filters.year) && filters.year > 0;

  return useQuery({
    queryKey: teacherEquityNationalKpisQueryKeys.national(filters),
    queryFn: () =>
      teacherEquityReportApi.getNationalKpis({
        year: filters.year!,
        roleIds: filters.roleIds,
        qualificationIds: filters.qualificationIds,
      }),
    enabled,
    staleTime: 2 * 60 * 1000,
    /** Search is explicit; avoid an extra GET when focus returns after clicking the button. */
    refetchOnWindowFocus: false,
  });
}
